import { IncidentFilterMeta } from '@src/main/modules/other_incidents/ui/hooks/mapIncidentFiltersToCriteria';
import { DataTableFilterMeta } from 'primereact/datatable';

export const useIncidentFilterHandler = (
  setFilters: (filters: IncidentFilterMeta) => void,
  refetch: () => void,
  setInvalidDateModalVisible: (visible: boolean) => void,
) => {
  type FilterConstraint = {
    value: unknown;
    matchMode?: string;
  };

  type FilterWithConstraints = {
    value?: unknown;
    constraints?: FilterConstraint[];
    matchMode?: string;
  };

  type DateRange = {
    from: string;
    to: string;
  };

  const getConstraint = (filter?: FilterWithConstraints) => {
    if (!filter) return null;

    if (filter.value !== undefined) {
      return {
        value: filter.value,
        matchMode: filter.matchMode,
      };
    }

    return filter.constraints?.[0] ?? null;
  };

  const mapFilter = (filter?: FilterWithConstraints) => {
    const constraint = getConstraint(filter);

    if (!constraint || constraint.value == null) return null;

    const { value, matchMode } = constraint;

    if (matchMode === 'between') {
      if (!Array.isArray(value)) return null;

      const [start, end] = value;

      if (!(start instanceof Date) || !(end instanceof Date)) return null;

      return {
        from: start.toISOString(),
        to: end.toISOString(),
      };
    }

    return value;
  };

  const isDateRange = (value: unknown): value is DateRange =>
    typeof value === 'object' && value !== null && 'from' in value && 'to' in value;

  const isInvalidDateRange = (range: DateRange): boolean => {
    const from = new Date(range.from);
    const to = new Date(range.to);

    return from > to;
  };

  const handleSetFilters = (newFilters: DataTableFilterMeta) => {
    const filtersTyped = newFilters as IncidentFilterMeta;

    const incidentDate = mapFilter(filtersTyped.incidentDate);
    const updatedAt = mapFilter(filtersTyped.updatedAt);

    if (
      (isDateRange(incidentDate) && isInvalidDateRange(incidentDate)) ||
      (isDateRange(updatedAt) && isInvalidDateRange(updatedAt))
    ) {
      setInvalidDateModalVisible(true);
      return;
    }

    setFilters(filtersTyped);

    refetch();
  };

  return { handleSetFilters };
};
